import React from "react";
import { Helmet } from "react-helmet-async";
import RetailProgress from "./retail";
import VendorProgress from "./vendor";
import useGlobalStore from "src/store/useGlobalStore";

const ModuleProgress = ({ match }) => {
  const { id } = match.params;
  const isRetail = useGlobalStore((state) => state.isRetail);

  return (
    <>
      <Helmet title="Spiffy | Module Report" />
      {isRetail ? <RetailProgress id={id} /> : <VendorProgress id={id} />}
    </>
  );
};

export default ModuleProgress;
